module.exports = __webpack_public_path__ + "img/bb_m_2.9d4f4115.jpg";